import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/resetPassword`;

export const ROUTE: RouteDefinition = `${baseRoute}/resetPassword`;

export const URL = (): RouteDefinition => `${baseRoute}/resetPassword`;
